import React from 'react';
import { Poppins } from 'src/common';
import styled from 'styled-components';

const Div = styled.div`
  border: 1px dashed ${({ theme }) => theme.colors.cflowerBlue};
  border-radius: 6px;
  padding: 9px 12px;
`;

interface FrequencyIndicatorProps {
  times?: number | null;
  years?: number | null;
}

export const FrequencyIndicator: React.FC<FrequencyIndicatorProps> = ({ times, years }) => {
  const calculatePercentage = () => {
    if (!times || !years || years === 0) return 'N/A';
    const percentage = (times / years) * 100;
    const value = Math.round(percentage);
    return Math.max(0, Math.min(100, value));
  };

  return (
    <Div>
      <Poppins px={14} color="prussianBlue">
        <i>The expected chance to happen in the next year: {calculatePercentage()}%</i>
      </Poppins>
    </Div>
  );
};
